import React from "react"
import { Container, CardTitle, Button } from "reactstrap"
import NoData from "../../assets/images/not-found.svg"
import { Link } from "react-router-dom"

const NotFound = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <React.Fragment>
            <div
              className={
                "py-5 d-flex flex-column align-items-center justify-content-between"
              }
            >
              <img
                src={NoData}
                style={{
                  maxWidth: "300px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "32px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                }}
              >
                {`Oops! We lost the page.`}
              </h4>
              <p
                style={{
                  color: "#000000",
                  fontSize: "16px",
                }}
              >
                {`The page you're looking for doesn't exist or has been moved.`}
              </p>

              <div className="buttons">
                <Link to={"/dashboard"}>
                  <Button type="button" className="primary">
                    Return to Dashboard
                  </Button>
                </Link>
              </div>
            </div>
          </React.Fragment>
        </Container>
      </div>
    </>
  )
}

export default NotFound
